import { platformBrowser } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { datadogRum } from '@datadog/browser-rum';

import { environment } from '@/environments/environment';
import { AppModule } from '@/app/app.module';
import * as SentryUtils from '@/app/core/utils/sentry';

// Session Replay EVERYTHING for Outside the Americas (temporary)
const timezone = -(new Date().getTimezoneOffset() / 60);
const sessionSampleRate =
  timezone > -2 && environment.platform === 'Production'
    ? 100
    : environment.dataDogSessionSampleRate;
const sessionReplayRate =
  timezone > -2 && environment.platform === 'Production'
    ? 100
    : environment.dataDogSessionReplayRate;

datadogRum.init({
  applicationId: '3ed9a104-be15-47c0-ad81-88a25cf1a2aa',
  clientToken: 'pub92a9be2f070e40e128d7693142f89440',
  site: 'datadoghq.com',
  service: 'rdo',
  env: environment.platform,
  sessionSampleRate: sessionSampleRate,
  sessionReplaySampleRate: sessionReplayRate,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

// Sentry.addTracingExtensions();
Sentry.init({
  environment: environment.platform,
  dsn: 'https://8827ba54c91f4331baabb37cb3320e81@o940752.ingest.sentry.io/6161354',
  release: environment.softwareVersion,
  ignoreErrors: [
    'Non-Error exception captured',
    'Uncompressed Asset',
    "TypeError: You provided 'undefined' where a stream was expected",
  ],
  // https://docs.sentry.io/platforms/javascript/configuration/options/#beforeSend
  /*
  the first argument (event) gives you the structured
  data that Sentry is about to send, that data has already been processed, normalized,
  and stripped of complex JavaScript objects.The hint argument gives you access to the live,
  environment-specific objects that triggered the error in the first place.
   */
  beforeSend(
    sentryError: Sentry.ErrorEvent,
    hint: Sentry.EventHint
  ): Sentry.ErrorEvent | null {
    console.log('main.beforeSend  received event', sentryError, hint);
    let event: Sentry.ErrorEvent | null = SentryUtils.processSentryLocalhost(
      sentryError,
      hint
    );

    if (!event) {
      return null;
    }

    event = SentryUtils.processSentryTransientHttpErrors(sentryError, hint);

    // stop sending events to Sentry because they can spam the system when a user loses
    // connectivity.
    if (event.tags?.error_type === 'transient_network') {
      return null;
    }

    event = SentryUtils.processSentryHttpErrorFingerprint(event, hint);

    return event;
  },
  integrations: [
    Sentry.browserTracingIntegration({
      instrumentNavigation: true,
    }),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // tracesSampleRate is configured per environment via environment.sentryTraceSampleRate.
  // - Production typically uses 0.4 to limit overhead and Sentry costs while still sampling enough traffic
  //   for meaningful performance insights.
  // - Staging uses 1.0 to capture 100% of transactions for more complete diagnostics and testing.
  tracesSampleRate: environment.sentryTraceSampleRate,
  tracePropagationTargets: ['localhost', /^https:\/\/.*rouseanalytics\.com/],

  // Replay for 100% of sessions with an error in production and stage
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: environment.platform === 'Production' ? 1.0 : 0,
});

//, {
//     providers: [
//       importProvidersFrom(TooltipModule.forRoot(RDOTooltipOptions as TooltipOptions)),
//     ]
//   }
platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
// bootstrapApplication(AppComponent)

if (environment.platform === 'Production' && window) {
  window.console.log = function () {};
  window.console.warn = function () {};
  window.console.error = function () {};
  window.console.time = function () {};
  window.console.timeEnd = function () {};
}
